import { Alert, Flex } from '@wyz/ui';
import { Trans } from '~/common/context';
import { NoResultsBanner } from '~/purchase/components';

type Props = {
  maxSearchExceeded: boolean;
  hasNoResults: boolean;
  count: number | undefined;
};
function SearchErrors({ maxSearchExceeded, hasNoResults, count }: Props) {
  return (
    <Flex alignItems='center' justifyContent='end' className='w-100'>
      {maxSearchExceeded && (
        <Alert variant='danger' className='mt-1'>
          <Trans
            i18nKey='app.purchase.search_page.search_max_count'
            values={{
              count,
            }}
          />
        </Alert>
      )}
      {hasNoResults && <NoResultsBanner className='mt-1' />}
    </Flex>
  );
}

export default SearchErrors;
